import {
  Dispatch,
  memo,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';

import {
  Card,
  Col,
  CardBody,
  Form,
  Row,
  Input,
  Label,
  Button,
  Table,
  CardHeader,
  FormGroup,
} from 'reactstrap';

import { CircularProgress, Typography } from '@material-ui/core';
import api from 'services/api';
import { PropostaVersaoServico } from 'models/PropostaVersaoServico';
import { PropostaContext } from 'views/pages/Proposta';
import InputSelect from 'components/InputSelect';
import OrcamentoCalculoServicoLogs from 'models/OrcamentoCalculoServicoLogs';
import Swal from 'sweetalert2';
import cepPromise from 'cep-promise';
import ValidarAcessoPrograma from 'models/ValidarAcessoPrograma';
import { useAuth } from 'hooks/auth';
// import toast from 'react-hot-toast';

function CamposAvalista({
  label,
  value,
  bloquear,
  onChange,
}: {
  label: string;
  value: string;
  bloquear: boolean | false;
  onChange: Dispatch<SetStateAction<string>>;
}): JSX.Element {
  return (
    <Row className="mb-3">
      <Col sm="2" xs="12">
        <Label className="form-control-label mt-3">{label}</Label>
      </Col>
      <Col sm="4" xs="12">
        <Input
          className="form-control-alternative"
          type="text"
          value={value}
          disabled={bloquear}
          onChange={text => onChange(text.target.value)}
        />
      </Col>
    </Row>
  );
}

function AvalistaObra(): JSX.Element {
  const {
    propostaVersao,
    acessoLimitado,
    formatoMaoDeObra,
    setFormatoMaoDeObra,
    carregaPropostaVersao,
    atualizarTelaProposta,
  } = useContext(PropostaContext);
  const { usuario } = useAuth();
  const [carregandoDados, setCarregandoDados] = useState(false);
  const [updatingAvalista, setUpdatingAvalista] = useState(false);

  const [necessitaAvalista, setNecessitaAvalista] = useState(false);
  const [nomeAvalista, setNomeAvalista] = useState('');
  const [documentoAvalista, setDocumentoAvalista] = useState('');
  const [enderecoAvalista, setEnderecoAvalista] = useState('');
  const [maoObraSupervisao, setMaoObraSupervisao] = useState('');
  const [maoObraAuxiliar, setMaoObraAuxiliar] = useState('');
  const [alimentacao, setAlimentacao] = useState('');
  const [estadia, setEstadia] = useState('');
  const [munck, setMunck] = useState('');
  const [retroescavadeira, setRetroescavadeira] = useState('');
  const [civil, setCivil] = useState('');
  const [descargaMaterial, setDescargaMaterial] = useState('');
  const [deslocamentoCidadeObra, setDeslocamentoCidadeObra] = useState('');
  const [km, setKm] = useState(0);
  const [numerosAuxiliares, SetNumerosAuxiliares] = useState(0);
  const [acessoLimitadoAvalista, setAcessoLimitadoAvalista] = useState(
    {} as ValidarAcessoPrograma,
  );

  const [cep, setCep] = useState('');
  const [estado, setEstado] = useState('');
  const [cidade, setCidade] = useState('');
  const [bairro, setBairro] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [cepInvalido, setCepInvalido] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);
  const [pais, setPais] = useState('');
  const [updatingEnderecoAvalista, setUpdatingEnderecoAvalista] =
    useState(false);

  const formatoAvalistaObraOptions = [
    { value: 'true', name: 'Sim' },
    { value: 'false', name: 'Não' },
  ];

  async function carregaAvalistaObra() {
    try {
      setCarregandoDados(true);
      setNecessitaAvalista(propostaVersao.necessitaAvalista || false);
    } finally {
      setCarregandoDados(false);
    }
  }

  function limpaCamposLocal() {
    setEstado('');
    setCidade('');
    setBairro('');
    setLogradouro('');
  }

  // async function handleUpdateAvalista() {
  //   if (
  //     !logradouro ||
  //     logradouro === '' ||
  //     logradouro === null ||
  //     logradouro === undefined ||
  //     !bairro ||
  //     bairro === '' ||
  //     bairro === null ||
  //     bairro === undefined
  //   ) {
  //     toast.error(
  //       'Todos os campos marcados com * são de preenchimento obrigatório!',
  //     );
  //     return;
  //   }
  //   try {
  //     setUpdatingAvalista(true);
  //     await api.put(`/proposta/${propostaVersaoId}/local-obra`, {
  //       logradouro,
  //       numero: numero ? String(numero) : null,
  //       complemento,
  //       bairro,
  //       cep,
  //       municipio: cidade,
  //       uf: estado,
  //       pais,
  //       propostaVersaoId,
  //       condicaoFrete,
  //       inscricaoEstadual: inscricaoEstadual ? String(inscricaoEstadual) : null,
  //     });
  //   } finally {
  //     setUpdatingAvalista(false);
  //     carregaLocalObra();
  //     atualizarTelaProposta(true);
  //   }
  // }

  async function buscaCep(cepInput: string) {
    if (cepInput.length <= 7) {
      return;
    }
    try {
      setBuscandoCep(true);
      setBairro('');
      setLogradouro('');
      const response = await cepPromise(cepInput);
      setEstado(response.state);
      setCidade(response.city);
      setBairro(response.neighborhood);
      setLogradouro(response.street);
      setCepInvalido(false);
    } catch {
      limpaCamposLocal();
      setCepInvalido(true);
    } finally {
      setBuscandoCep(false);
    }
  }

  async function carregaAvalista() {
    if (propostaVersao.id) {
      try {
        setCarregandoDados(true);
        const response = await api.get(
          `/proposta/versao/${propostaVersao.id}/avalista`,
        );
        if (response.data) {
          const avalista = response.data;
          setNomeAvalista(avalista.nomeAvalista || '');
          setDocumentoAvalista(avalista.documentoAvalista || '');
          setCep(avalista.cep || '');
          setEstado(avalista.uf || '');
          setCidade(avalista.municipio || '');
          setBairro(avalista.bairro || '');
          setLogradouro(avalista.logradouro || '');
          setNumero(avalista.numero || '');
          setComplemento(avalista.complemento || '');

          const isExterior = Boolean(avalista.exterior);
          setPais(isExterior ? avalista.pais : 'Brasil');
        } else {
          // limpa os campos caso não exista avalista
          setNomeAvalista('');
          setDocumentoAvalista('');
          setCep('');
          setEstado('');
          setCidade('');
          setBairro('');
          setLogradouro('');
          setNumero('');
          setComplemento('');
          setPais('Brasil');
        }
      } finally {
        setCarregandoDados(false);
      }
    }
  }

  async function getAcessoAvalista() {
    const response = await api.get('/acesso-programa/acesso-programa', {
      params: {
        programaId: 128,
        usuarioId: usuario.id,
      },
    });
    console.log('Acesso Avalista:', response.data);
    setAcessoLimitadoAvalista(response.data);
  }

  useEffect(() => {
    carregaAvalista();
  }, []);

  function handleInputCep(cepInput: string) {
    if (!cepInput) {
      limpaCamposLocal();
    }
    setCepInvalido(false);

    buscaCep(cepInput);
  }

  useEffect(() => {
    carregaAvalistaObra();
    getAcessoAvalista();
  }, [propostaVersao]);

  async function handleUpdateAvalista() {
    // let temAprovacao = false;
    try {
      setUpdatingAvalista(true);
      const retorno = await api.put(
        `/proposta/versao/${propostaVersao.id}/avalista`,
        {
          necessitaAvalista,
          nomeAvalista,
          documentoAvalista,
          logradouro,
          numero: numero ? String(numero) : null,
          complemento,
          bairro,
          cep,
          municipio: cidade,
          uf: estado,
          pais,
        },
      );
    } finally {
      setUpdatingAvalista(false);
    }
  }

  return (
    <Card className="bg-secondary shadow mt-1 mb-1">
      <CardBody>
        <Form>
          <Row className="ml-0">
            <h6 className="heading-small text-muted mb-1">Avalista</h6>
            {carregandoDados && (
              <CircularProgress
                className="mt-2 ml-2"
                color="inherit"
                size={10}
              />
            )}
          </Row>
          <hr className="mt-2" />

          <Row className="mb-3">
            <Col sm="2" xs="12">
              <Label className="form-control-label mt-3">
                Necessita Avalista?
              </Label>
            </Col>
            <Col sm="4" xs="12">
              <InputSelect
                value={necessitaAvalista ? 'true' : 'false'}
                disabled={!acessoLimitadoAvalista.temAcesso}
                onChange={e => setNecessitaAvalista(e.target.value === 'true')}
                options={formatoAvalistaObraOptions}
                hideNoOption
              />
            </Col>
          </Row>

          <hr className="mt-2" />

          {necessitaAvalista && (
            <>
              <div className="mb-5">
                <CamposAvalista
                  label="Nome do Avalista *"
                  value={nomeAvalista}
                  onChange={setNomeAvalista}
                  bloquear={!acessoLimitadoAvalista.temAcesso}
                />
                <CamposAvalista
                  label="CPF/CNPJ do Avalista *"
                  value={documentoAvalista}
                  onChange={setDocumentoAvalista}
                  bloquear={!acessoLimitadoAvalista.temAcesso}
                />
                {/* <CamposAvalista
                  label="Endereço do Avalista *"
                  value={enderecoAvalista}
                  onChange={setEnderecoAvalista}
                  bloquear={acessoLimitado}
                /> */}
              </div>
              <>
                <Card className="bg-secondary shadow mt-1 mb-1">
                  <CardBody>
                    <Form>
                      <Row className="ml-0">
                        <h6 className="heading-small text-muted mb-1">
                          Endereço do Avalista *
                        </h6>
                        {carregandoDados && (
                          <CircularProgress
                            className="mt-2 ml-2"
                            color="inherit"
                            size={10}
                          />
                        )}
                      </Row>

                      <hr className="mt-2" />
                      <div className="pl-lg-3">
                        <Row>
                          <Col lg="2" xs="12">
                            <FormGroup>
                              <Label className="form-control-label">
                                País *
                              </Label>
                              <Input
                                className="form-control-alternative"
                                type="text"
                                disabled={!acessoLimitadoAvalista.temAcesso}
                                value={pais}
                                onChange={text => setPais(text.target.value)}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="2" xs="12">
                            <FormGroup>
                              <Label className="form-control-label">
                                CEP *
                              </Label>
                              {buscandoCep && (
                                <CircularProgress
                                  className="ml-2"
                                  color="inherit"
                                  size={10}
                                />
                              )}
                              <Input
                                className="form-control-alternative"
                                type="text"
                                value={cep}
                                disabled={!acessoLimitadoAvalista.temAcesso}
                                onInput={event =>
                                  handleInputCep(event.currentTarget.value)
                                }
                                onChange={text => setCep(text.target.value)}
                              />
                              {cepInvalido && (
                                <Typography
                                  className="mt-2"
                                  variant="caption"
                                  display="block"
                                  style={{ color: '#ed5565' }}
                                >
                                  CEP inválido
                                </Typography>
                              )}
                            </FormGroup>
                          </Col>
                          <Col lg="2" xs="12">
                            <FormGroup>
                              <Label className="form-control-label">
                                Estado *
                              </Label>
                              <Input
                                className="form-control-alternative"
                                type="text"
                                disabled={!acessoLimitadoAvalista.temAcesso}
                                value={estado}
                                onChange={text => setEstado(text.target.value)}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="3" xs="12">
                            <FormGroup>
                              <Label className="form-control-label">
                                Cidade *
                              </Label>
                              <Input
                                className="form-control-alternative"
                                type="text"
                                disabled={!acessoLimitadoAvalista.temAcesso}
                                value={cidade}
                                onChange={text => setCidade(text.target.value)}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="3" xs="12">
                            <FormGroup>
                              <Label className="form-control-label">
                                Bairro *
                              </Label>
                              <Input
                                className="form-control-alternative"
                                type="text"
                                value={bairro}
                                disabled={!acessoLimitadoAvalista.temAcesso}
                                onChange={text => setBairro(text.target.value)}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6" xs="12">
                            <FormGroup>
                              <Label className="form-control-label">
                                Logradouro *
                              </Label>
                              <Input
                                className="form-control-alternative"
                                type="text"
                                value={logradouro}
                                disabled={!acessoLimitadoAvalista.temAcesso}
                                onChange={text =>
                                  setLogradouro(text.target.value)
                                }
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="2" xs="6">
                            <FormGroup>
                              <Label className="form-control-label">
                                Número *
                              </Label>
                              <Input
                                className="form-control-alternative"
                                type="text"
                                value={numero}
                                disabled={!acessoLimitadoAvalista.temAcesso}
                                onChange={text => setNumero(text.target.value)}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="4" xs="6">
                            <FormGroup>
                              <Label className="form-control-label">
                                Complemento
                              </Label>
                              <Input
                                className="form-control-alternative"
                                type="text"
                                value={complemento}
                                disabled={!acessoLimitadoAvalista.temAcesso}
                                onChange={text =>
                                  setComplemento(text.target.value)
                                }
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        {/* <Row>
                          <Col sm="10" />
                          <Col sm="2">
                            <Button
                              className="float-right"
                              color="default"
                              disabled={updatingEnderecoAvalista}
                              onClick={handleUpdateEnderecoAvalista}
                            >
                              {updatingEnderecoAvalista
                                ? 'Salvando...'
                                : 'Salvar'}
                            </Button>
                          </Col>
                        </Row> */}
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </>
            </>
          )}

          <Row>
            <Col sm="9" />
            <Col sm="3">
              <Button
                className="float-right"
                color="default"
                disabled={updatingAvalista}
                onClick={handleUpdateAvalista}
              >
                {updatingAvalista
                  ? 'Salvando informação na proposta...'
                  : 'Salvar'}
              </Button>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  );
}

export default memo(AvalistaObra);
